import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";

// import { api } from "../setup/API/api";
import { useEffect, useState } from "react";

export type IAutoCompletedOperadoraImport = {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
  layouts: {
    file_type: string;
    delimiter: string | null;
    has_header: boolean;
    sheet_name: string | null;
    encoding: string;
    layout_fields: {
      id: string;
      system_field: string;
      column_name: string;
      column_index: number | null;
    }[];
  }[];
};

export const useGetOperatorsImport = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState<IAutoCompletedOperadoraImport[]>([]);

  useEffect(() => {
    const handleGet = () => {
      setLoading(true);

      // api
      //   .get(`/bordero-importLayoutsAll`)
      //   .then(({ data }) => {
      //     setData(data);
      //   })
      //   .catch((error) =>
      //     handleGetAlert({ message: error.response.data.message })
      //   )
      //   .finally(() => setLoading(false));
    };

    handleGet();
  }, []);

  return { data, loading };
};
